import { AppConfig } from "AppConfig";
import { useOrg } from "components/OrgProvider";
import { addDays } from "Constants";
import * as FirebaseConfigs from 'FirebaseConfigs';
import { FirebaseUtils } from "firebaseUtils/FirebaseUtils";
import { AnalyticsEvent } from "models/AnalyticsEvent";
import { DbDoc, WithRef } from "models/FbDoc";
import { Nullable } from "models/Nullable";
import { Org } from "models/Org";
import { OrgSubscription, SubscriptionStatus } from "models/OrgSubscription";
import { useDocumentData } from "react-firebase-hooks/firestore";

export function useSubscriptionStatus(): [subscriptionActive: boolean, loadingSubscription: boolean, subscriptionStatus?: SubscriptionStatus] {
    const [orgDoc] = useOrg()
    const orgId = orgDoc?.data.id
    const [orgSubscription, loadingOrgSubscription, error] = useDocumentData<OrgSubscription>(orgId ? FirebaseConfigs.persistedDb.collection('OrgSubscriptions').doc(orgId) : null)
    FirebaseUtils.useErrorLogger(error, AnalyticsEvent.GET_ORG_SUBSCRIPTIONS_ERROR)
    const hasFreeStandardSubscription = !!orgSubscription?.adminOverrides.freeStandard.active
    return [(orgSubscription?.status === "active") || hasFreeStandardSubscription, loadingOrgSubscription, orgSubscription?.status]
}

function datediff(date1: Date, date2: Date) {
    // @ts-ignore
    const diffTime = date2 - date1
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    return diffDays
}

export function getTrial(org?: Nullable<WithRef<DbDoc<Org>>>): [trialActive: boolean, daysLeft: number, endsAt: Date] {
    // @ts-ignore
    const endsAt = org ? addDays(Math.max(org?.metadata.createdAt.toDate(), AppConfig.COUNT_SUBSCRIPTIONS_FROM), AppConfig.TRIAL_PERIOD) : new Date()

    const daysLeft = org ? datediff(new Date(), endsAt) : 0

    return [
        daysLeft > 0,
        daysLeft,
        endsAt,
    ]
}

export function useFreeTrial(): [trialActive: boolean, loadingTrial: boolean, daysLeft: number, endsAt: Date] {
    const [org, loadingOrg] = useOrg()
    const [trialActive, daysLeft, endsAt] = getTrial(org)
    return [
        trialActive,
        loadingOrg,
        daysLeft,
        endsAt,
    ]
}

export function useSubscriptionAccess(): [subscriptionActive: boolean, loadingSubscription: boolean, subscriptionStatus?: SubscriptionStatus] {
    const [active, loadingStatus] = useSubscriptionStatus()
    const [trial, loadingTrial] = useFreeTrial()
    return [active || trial || !AppConfig.REQUIRE_SUBSCRIPTIONS, loadingStatus || loadingTrial]
}
